// extracted by mini-css-extract-plugin
export default {"root":"PlasmicEditIconBlue_root__bxwgS","img":"PlasmicEditIconBlue_img__5m1PF","imgrotated":"PlasmicEditIconBlue_imgrotated__OKRZn"};